export default __webpack_public_path__ + "static/media/informationCircle.ad7d356a.svg";